// extracted by mini-css-extract-plugin
export default {"tabs":"CRMDSAUserDetails_tabs__klkuq","active":"CRMDSAUserDetails_active__xUSWk"};